import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
//import { useNavigate } from "react-router-dom";

interface CreateProductProductProps {
  loading: boolean;
  hasSKU: boolean; // เพิ่ม prop สำหรับตรวจสอบว่ามี SKU หรือไม่
  isActive: boolean; // เปิดการขายอยู่หรือไม่ — บังคับต้องมี SKU เฉพาะเมื่อเปิดการขาย
}

const CreateProductProduct: FC<CreateProductProductProps> = ({ loading, hasSKU, isActive }) => {
 // const navigate = useNavigate();

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            disabled={isActive && !hasSKU} // ปิดการใช้งานปุ่มเฉพาะเมื่อเปิดการขายแต่ยังไม่มี SKU
            style={{ width: 200 }}
          size="large"
          >
            สร้างสินค้า
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default CreateProductProduct;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
